import { EXPERIMENTS, getAssignedExperimentBucket } from '@src/experiments'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

const SHOPIFY_PRODUCT_ID = new Set<number>([
  7777176649898, 7777031913642, 7777030766762, 7777015595178, 7777172422826, 7777163608234, 7777163346090,
  7777162690730, 7777034109098, 7777033289898, 7777032601770, 7777031422122, 7777162690730, 7777034109098,
  7777033289898, 7777027227818, 7777015038122, 7777162690730, 7776874135722, 7777029226666, 7705330548906,
  7777015038122, 7777003667626, 7705333924010, 7705323077802, 7705317540010, 7705316917418, 7705057624234,
  7705056247978, 7705055625386, 7705053823146, 7705052905642, 7705047892138, 7705042878634, 7703044948138,
  7703036231850, 7702992683178, 7702976790698, 7702846505130, 7702841000106, 7705047892138, 7702820552874,
  7702818586794, 7702811246762, 7702798991530, 7702786539690, 7702776119466, 7702771171498, 7702749708458,
  7702192357546, 7702190293162, 7702181675178, 7702120661162, 7702119874730, 7701993324714, 7701986050218,
  7701984051370, 7701981855914, 7701981003946, 7701972549802, 7701968552106, 7701960392874, 7698757845162,
  7698755256490, 7698754601130, 7700720255146, 7698740510890, 7698736447658, 7698718294186, 7698715148458,
  7698713018538, 7698707677354, 7698695192746, 7695981346986, 7695971745962, 7695964831914, 7695820390570,
  7704455807146, 7693933740202, 7693927186602, 7693922926762, 7693920862378, 7693919649962, 7693904412842,
  7693018955946, 7692977209514, 7692969410730, 7692951191722, 7692949422250, 7692947030186, 7692943294634,
  7692924813482, 7690493264042, 7690486939818, 7690412785834, 7688913944746, 7688911814826, 7688906440874,
  7688905490602, 7688901722282, 7688824258730, 7655815020714, 7655897268394, 7655899431082, 7655903330474,
  7656473985194, 7656499445930, 7451123089578, 7451855782058, 7451836743850, 7436344492202, 7436346294442,
  7441767858346, 7436353634474, 7436356845738, 7436362743978, 7436373328042, 7376657612970, 7376664723626,
  7376669737130, 7347979878570, 7346923045034, 7376688840874, 7376743923882, 7377949720746, 7253472542890,
  7255091118250, 6758954926250, 6758942474410, 6758868582570, 6087117373610, 6087116685482, 6073243664554,
  7535300018346, 7535298805930, 7535299821738, 7535297495210, 7535298085034, 7535297757354, 7559006355626,
  7559005896874, 7524062331050, 7524061708458, 7524062003370, 7524060987562, 7524061315242, 7559006191786,
  7559006355626, 7559006617770, 7559004782762, 7559006519466, 7559005143210, 7444454080682, 7446314713258,
  7444450148522, 7444400144554, 7446317269162, 7443180847274, 7443176685738, 7443166003370, 7443198148778,
  7443206373546, 7444437172394, 7777030504618, 7705326092458, 7705057624234, 7705056247978, 7498439655594,
  6751714410666, 7310228881578, 7379782795434, 7379785056426, 7379783483562, 7379791970474, 7379779256490,
])
// If we are adding more products to this list kindly
// follow up to get the ticket prioritised for automating this flow
// https://lastbrand.atlassian.net/browse/STRFRNT-4672

export const isReadyToShipTagSupportedForProduct = (productId: number) =>
  productId ? SHOPIFY_PRODUCT_ID.has(productId) : false

export function shouldShowBuyNowBasedOnDeviceType(isMobile: boolean) {
  if (!isMobile) return true
  if (!isBrowser()) return false
  const bucket = getAssignedExperimentBucket(EXPERIMENTS.SHOW_ATC_ON_MOBILE.experimentName)
  return bucket === EXPERIMENTS.SHOW_ATC_ON_MOBILE?.bucketNames.show
}
